/**
 * TabelaOpreme
 * Prikazuje izabrana sredstva u tabeli.
 * Lokacija i objekat (samo za ORMARIC) se unose ručno inline.
 * Svako sredstvo može biti uklonjeno.
 */

const styles = {
  wrapper: {
    border: "1px solid #ccc",
    borderRadius: "4px",
    overflow: "hidden",
    backgroundColor: "#fff"
  },
  header: {
    backgroundColor: "#e8e8e8",
    padding: "6px 10px",
    fontSize: "12px",
    fontWeight: "bold",
    textTransform: "uppercase",
    color: "#555"
  },
  emptyMsg: {
    padding: "16px",
    textAlign: "center",
    color: "#aaa",
    fontSize: "13px"
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "12px"
  },
  th: {
    backgroundColor: "#f2f2f2",
    padding: "6px 8px",
    textAlign: "left",
    fontWeight: "bold",
    borderBottom: "1px solid #ddd",
    whiteSpace: "nowrap"
  },
  td: {
    padding: "5px 8px",
    borderBottom: "1px solid #eee",
    verticalAlign: "middle"
  },
  input: {
    width: "100%",
    padding: "3px 5px",
    border: "1px solid #ccc",
    borderRadius: "3px",
    fontSize: "12px",
    minWidth: "100px"
  },
  deleteBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#c00",
    fontWeight: "bold",
    fontSize: "14px",
    padding: "0 4px"
  }
};

// Kolone koje se prikazuju za svaku kategoriju
const KOLONE = {
  RADNA_MASINA: ["naziv", "proizvodjac", "tip_model", "serijski_broj", "registracija", "strucni_nalaz_broj", "lokacija"],
  MASINA_UREDJAJ: ["naziv", "tip_model", "serijski_broj", "strucni_nalaz_broj", "lokacija"],
  ORMARIC: ["naziv", "oznaka", "serijski_broj", "strucni_nalaz_broj", "lokacija", "objekat"]
};

const KOLONE_NAZIVI = {
  naziv: "Назив",
  proizvodjac: "Произвођач",
  tip_model: "Тип / Модел",
  serijski_broj: "Серијски број",
  registracija: "Регистрација",
  strucni_nalaz_broj: "Бр. претх. налаза",
  lokacija: "Локација",
  objekat: "Објекат"
};

const EDITABILNE = ["lokacija", "objekat"];

function TabelaOpreme({ sredstva, setData }) {
  if (!sredstva || sredstva.length === 0) {
    return (
      <div style={styles.wrapper}>
        <div style={styles.header}>Средства и опрема</div>
        <div style={styles.emptyMsg}>
          Нису додата средства. Кликните „Додај средство".
        </div>
      </div>
    );
  }

  // Grupiši po kategoriji
  const grupisano = sredstva.reduce((acc, s) => {
    const kat = s.kategorija || "OSTALO";
    if (!acc[kat]) acc[kat] = [];
    acc[kat].push(s);
    return acc;
  }, {});

  const handleInlineChange = (masina_id, field, value) => {
    setData(prev => ({
      ...prev,
      sredstva: prev.sredstva.map(s =>
        s.masina_id === masina_id ? { ...s, [field]: value } : s
      )
    }));
  };

  const handleUkloni = (masina_id) => {
    setData(prev => ({
      ...prev,
      sredstva: prev.sredstva.filter(s => s.masina_id !== masina_id)
    }));
  };

  const KATEGORIJA_NAZIV = {
    RADNA_MASINA: "Радне машине",
    MASINA_UREDJAJ: "Машине и уређаји",
    ORMARIC: "Градилишни ормарићи"
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      {Object.entries(grupisano).map(([kategorija, lista]) => {
        const kolone = KOLONE[kategorija] || ["naziv", "serijski_broj", "lokacija"];

        return (
          <div key={kategorija} style={styles.wrapper}>
            <div style={styles.header}>
              {KATEGORIJA_NAZIV[kategorija] || kategorija}
            </div>
            <div style={{ overflowX: "auto" }}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={{ ...styles.th, width: "24px" }}></th>
                    {kolone.map(k => (
                      <th key={k} style={styles.th}>
                        {KOLONE_NAZIVI[k] || k}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {lista.map((s) => (
                    <tr key={s.masina_id}>
                      <td style={styles.td}>
                        <button
                          style={styles.deleteBtn}
                          onClick={() => handleUkloni(s.masina_id)}
                          title="Уклони"
                        >
                          ✕
                        </button>
                      </td>
                      {kolone.map(k => (
                        <td key={k} style={styles.td}>
                          {EDITABILNE.includes(k) ? (
                            <input
                              type="text"
                              style={styles.input}
                              value={s[k] || ""}
                              placeholder={KOLONE_NAZIVI[k]}
                              onChange={(e) =>
                                handleInlineChange(s.masina_id, k, e.target.value)
                              }
                            />
                          ) : (
                            <span>{vrednost(s, k)}</span>
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </div>
  );
}

// Mapiranje API polja → kolona u tabeli
function vrednost(s, kolona) {
  switch (kolona) {
    case "naziv":       return s.vrsta_naziv || "-";
    case "proizvodjac": return s.proizvodjac || "-";
    case "tip_model":   return s.tip || "-";
    case "serijski_broj": return s.oznaka || "-";   // u bazi oznaka = serijski/fabr. broj
    case "registracija":  return s.registracija || "-";
    case "strucni_nalaz_broj": return s.strucni_nalaz_broj || "-";
    case "oznaka":      return s.oznaka || "-";     // za ormarić = oznaka RO-1
    default:            return s[kolona] || "-";
  }
}

export default TabelaOpreme;